export default __webpack_public_path__ + "static/media/safety-seat.902a9d4b.svg";